<template>
  <div class="app">
    <client-only>
      <ImpersonationBanner />
    </client-only>
    <Header />
    <nuxt />
    <Footer />
  </div>
</template>

<script>
export default {
  components: {
    Header: () => import("../components/header/Header"),
    Footer: () => import("../components/footer/Footer"),
    ImpersonationBanner: () => import("../components/elements/ImpersonationBanner"),
  },
  middleware: "permissions",
};
</script>

<style>
.app {
  background-color: rgb(249, 250, 251);
}
</style>
